declare global {
  interface Window {
    langManifest: Record<Language, string>;
  }
}

type RawLangData = Record<string, string[]>;

interface LangDataStorage {
  version: number; // 存储结构版本
  language: Language;
  hash: string;
  data: RawLangData;
}

const KEY = 'lang-data-trade';
const version = 1;

const langManifest = window.langManifest || {};

export function readLangRecord(language: Language) {
  const data = localStorage.getItem(KEY);
  if (!data) {
    return null;
  }

  const storageData = JSON.parse(data) as LangDataStorage;
  if (storageData.version !== version || storageData.hash !== langManifest[language]) {
    localStorage.setItem(KEY, '');
    return null;
  }

  return unzip(storageData.data);
}

export function writeLangRecord(language: Language, rawLangData: RawLangData) {
  localStorage.setItem(KEY, JSON.stringify({version, language, hash: langManifest[language], data: rawLangData}));
}

function unzip(rawLangData: RawLangData): LangRecord {
  const result = {};
  Object.keys(rawLangData).forEach((k) => {
    const ids = rawLangData[k];
    ids.forEach((id) => (result[id] = k));
  });
  return result;
}
